export { parseTime, formatTime } from '@/utils/index';

export function pluralize(time: number, label: string) {
  if (time === 1) {
    return time + label;
  }
  return time + label + 's';
}

export function timeAgo(time: number) {
  const between = Date.now() / 1000 - Number(time);
  if (between < 3600) {
    return pluralize(~~(between / 60), ' minute');
  } else if (between < 86400) {
    return pluralize(~~(between / 3600), ' hour');
  } else {
    return pluralize(~~(between / 86400), ' day');
  }
}

export function html2Text(val: string) {
  const div = document.createElement('div');
  div.innerHTML = val;
  return div.textContent || div.innerText;
}

export function getStatusName(value: any) {
  let _str = '';
  let _val = parseInt(value.order_service.state);
  if (_val < 330 && _val !== 553) {
    _str = '待处理';
  }
  if (_val >= 330 && _val < 770 && _val !== 553) {
    if (_val === 551) {
      _str = '上报中';
    } else {
      _str = '进行中';
    }
  }
  if (_val === 553) {
    _str = '挂单中';
  }
  if (_val > 770) {
    _str = '完结单';
  }
  return _str;
}

export function getOrderStatusName(value: any) {
  let _str = '';
  let _val = parseInt(value.order.state);
  if (_val <= 2) {
    _str = '待处理';
  }
  if (_val >= 3 && _val < 7) {
    _str = '进行中';
  }
  if (_val > 3 && _val < 7 && parseInt(value.order_service.is_task_finish) === 1) {
    _str = '待验收';
  }
  if (_val >= 7) {
    _str = '完结单';
  }
  return _str;
}

export function getMobileFormat(val: any) {
  let tel = val.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2");
  return tel
}
